import React from "react";

export default function LogoutIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M189-100q-43.725 0-74.863-31.137Q83-162.275 83-206v-548q0-43.725 31.137-74.862Q145.275-860 189-860h286v106H189v548h286v106H189Zm448-140-76-78 110-110H351v-106h320L561-644l76-76 240 240-240 240Z"/></svg>
    );
}
